import { Component, OnInit, Input } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { TestedIndividualService } from 'src/app/services/tested-individual.service';
import { MpjobService } from 'src/app/services/jobs/mpjob.service';
import { MedicalFromService } from 'src/app/services/medical-from.service';
import { MatSnackBar } from '@angular/material';

@Component({
  selector: 'app-form',
  templateUrl: './form.component.html',
  styleUrls: ['./form.component.scss']
})
export class FormComponent implements OnInit {

  showForm = true
  candidateList: any;
  jobId: any;
  loading;

  @Input('candidateName') candidateName;
  @Input('jobId') jobIdFromLearner;


  candidate: any;
  consentForm: any;
  mainForm: any;
  userId: any;
  consentFormData;
  medicalFormData;
  user: any;
  isUpdate: boolean;
  personalDetails: any;
  isEmail


  constructor(public router: Router, public activatedRoute: ActivatedRoute, public _mpJobService: MpjobService,
    public _testedIndividualService: TestedIndividualService, public _medicalFormService: MedicalFromService, public _snackBar: MatSnackBar) { }

  ngOnInit(): void {
    this.activatedRoute.params.subscribe(param => {
      console.log('param', param)
      if (param.jobId) {
        this.jobId = param.jobId
        this.getCandidates()
        this._testedIndividualService.getListByJobId(param.jobid).subscribe(res => {
          this.candidateList = res
        })
      }
      else if (param.id) {
        if (this.jobIdFromLearner) {
          this.jobId = this.jobIdFromLearner
          this.userId = param.id
          this.getMedicalRecord()
          this.getCandidates()
        }
        // alert('get candidate medical form details')
      }
    })

    this.activatedRoute.queryParams.subscribe(qparam => {
      if (qparam.jobId) {
        this.jobId = this.jobIdFromLearner
        // this.getCandidates()
      }
    })
  }

  // tempFunction(){
  //   this.showForm = false;
  // }

  consentFormEvent(event) {
    this.showForm = false;
    console.log("event", event)
    this.consentForm = event.consentForm
    this.personalDetails = event.consentForm.personalDetails
    this.candidate = event.consentForm.personalDetails.name
    this.user = event.user
    this.isEmail = event.email
  }

  mainFormEvent(event) {
    this.mainForm = event.mainForm
    this.saveForm()
  }

  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, {
      duration: 2000,
    });
  }



  mailSend(event) {
    console.log("event of mail send", event);
    let obj = {
      user: event.user,
      jobId: this.jobId
    }

    this._medicalFormService.sendClientMail(obj).subscribe((response) => {
      console.log("response mail send to clients", response);

    }, error => {
      console.log("error", error);

    })



  }


  saveForm() {
    this.loading = true;
    // let data = {
    //   consentForm: this.consentForm,
    //   mainForm: this.mainForm,
    //   userId: this.candidate.userId
    // }



    // console.log('Final Data To Submit', data);

    if (this.isUpdate) {
      let data = {
        form1: this.mainForm.form1,
        generalHealth: this.mainForm.generalHealth,
        vision: this.mainForm.vision,
        hearing: this.mainForm.hearing,
        fitness: this.mainForm.fitness,
        recom: this.mainForm.recom,
        personalDetails: this.consentForm.personalDetails,
        empHistory: this.consentForm.empHistory,
        medicalHistory: this.consentForm.medicalHistory,
        lifeStyle: this.consentForm.lifeStyle,
        confirm: this.consentForm.confirm,
        userId: this.consentFormData.userId,
        onModel: this.consentFormData.onModel,
        mpJob: this.consentFormData.mpJob,
        isEmail: this.isEmail
      }
      this._medicalFormService.updateMedicalRecord(data).subscribe((res) => {
        console.log('Res===>', res);
        this.openSnackBar('Record Updated Successfully!', 'OK')
        this.loading = false;
        this.router.navigateByUrl('/mpjob/' + this.jobId)
      })
    }
    else {
      console.log("this.mainForm.generalHealth =========>", this.mainForm.generalHealth)
      let data = {
        form1: this.mainForm.form1,
        generalHealth: this.mainForm.generalHealth,
        vision: this.mainForm.vision,
        hearing: this.mainForm.hearing,
        fitness: this.mainForm.fitness,
        recom: this.mainForm.recom,
        personalDetails: this.consentForm.personalDetails,
        empHistory: this.consentForm.empHistory,
        medicalHistory: this.consentForm.medicalHistory,
        lifeStyle: this.consentForm.lifeStyle,
        confirm: this.consentForm.confirm,
        userId: this.user.userId,
        onModel: this.user.userType,
        mpJob: this.user.jobId,
        isEmail: this.isEmail
      }
      this._medicalFormService.addMedicalRecord(data).subscribe((res) => {
        console.log('Res===>', res);
        this.openSnackBar('Record Added Successfully!', 'OK')
        this.loading = false;
        this.router.navigateByUrl('/job/mpjob/' + this.jobId)
      })
    }
  }

  getCandidates() {
    this._mpJobService.getAllCandidateList(this.jobId).subscribe(res => {
      console.log('res in form', res)
      this.candidateList = res
    })
  }

  getMedicalRecord() {
    this._medicalFormService.getMedicalRecord(this.userId).subscribe(res => {
      console.log('Medical Form Response Here', res)

      this.consentFormData = res;

      this.medicalFormData = res;

      if (res && res._id) {
        this.isUpdate = true
      }
      else this.isUpdate = false
      console.log('this.isUpdate==========>', this.isUpdate);
      // console.log('this.medicalFormData==========>', this.medicalFormData);

    })
  }

}
